import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = require('../locales/message.json')

const i18n = new VueI18n({
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'ja',
  messages
})

export const t = (value) => i18n.tc(value)

export default i18n
